
// 商品名フォームへ「選択したプロダクトカテゴリ 型番名」を自動入力する
export default class AutoInputItemName {
  static buildItemNameValue() {
    const hiddenItemNameField = document.getElementById('hidden_item_name_field');

    if(!hiddenItemNameField){ return; }

    const productCategorySelect0 = document.getElementById('productCategorySelectBlock0').getElementsByClassName('selModalButton')[0];
    const productCategorySelect1 = document.getElementById('productCategorySelectBlock1').getElementsByClassName('selModalButton')[0];
    const productCategorySelect2 = document.getElementById('productCategorySelectBlock2').getElementsByClassName('selModalButton')[0];
    const productCategorySelect3 = document.getElementById('productCategorySelectBlock3').getElementsByClassName('selModalButton')[0];
    const modelNumberFieldValue = document.getElementById('item_model_number').value;

    // 子プロダクトカテゴリー（スマホはひ孫プロダクトカテゴリー）が存在しない場合は非表示の商品名フィールドのvalueに
    // 「選択してください」の文字列が追加されるので空の文字列に変更
    let ChildProductCategorySelectValue = productCategorySelect1.innerHTML.trim();
    let GreatGrandChildProductCategorySelectValue = productCategorySelect3.innerHTML.trim();

    if(productCategorySelect1.innerHTML.trim() === '選択してください'){
      ChildProductCategorySelectValue = '';
    }
    if(productCategorySelect3.innerHTML.trim() === '選択してください'){
      GreatGrandChildProductCategorySelectValue = '';
    }

    // スマホは商品名に「子 孫 (ひ孫)」が入り、それ以外は「親 (子) (型番)」が入力される
    if(window.location.pathname.includes('phone')){
      hiddenItemNameField.value = `${productCategorySelect1.innerHTML.trim()} ${productCategorySelect2.innerHTML.trim()} ${GreatGrandChildProductCategorySelectValue}`;
    } else {
      hiddenItemNameField.value = `${productCategorySelect0.innerHTML.trim()} ${ChildProductCategorySelectValue} ${modelNumberFieldValue}`;
    }
  }
}
